<script lang="ts">
import { defineComponent } from 'vue';
import { Result, Button } from 'ant-design-vue';
import { useRouter } from 'vue-router';
import { string } from 'vue-types';

import HeadTitle from '@/ui/HeadTitle.vue';

export default defineComponent({
  name: '404',
  components: {
    HeadTitle,
    Result,
    Button,
  },
  props: {
    title: string(),
    subTitle: string(),
  },
  setup() {
    const router = useRouter();
    const goHome = () => {
      router.push('/');
    };
    return {
      goHome,
    };
  },
});
</script>

<template>
  <HeadTitle title="404" />
  <Result
    status="404"
    :title="title ?? '404 Not Found'"
    :sub-title="subTitle ?? 'Sorry, the page you visited does not exist.'"
  >
    <template #extra>
      <Button type="primary" @click="goHome">
        Back Home
      </Button>
    </template>
  </Result>
</template>
